import { InjectBaseModalProps } from "@/hooks/Modal/ModalStore";
import { Button, Modal } from "antd";
import { observer } from "mobx-react-lite";
import React from "react";
import FetchOrderErrorTable, { ShopFetchOrderError } from "./FetchOrderErrorTable";
import { openUrl } from "@/utils";

interface FetchOrderErrorModalProps extends InjectBaseModalProps {
    dataSource: ShopFetchOrderError[];
}

const FetchOrderErrorModal: React.FC<FetchOrderErrorModalProps> = function (props) {
    const { open, onCancel, dataSource } = props;

    const shouldShowCs = dataSource?.some(({ message }) => !message?.includes("店铺授权过期"));

    return (
        <Modal
            title="部分店铺订单列表加载失败"
            open={open}
            onCancel={onCancel}
            width={700}
            footer={
                <>
                    <Button onClick={onCancel}>关闭</Button>

                    {shouldShowCs ? (
                        <Button
                            danger
                            type="primary"
                            onClick={() => {
                                openUrl("https://v2.fahuoyi.com/cs");
                            }}
                        >
                            联系客服反馈
                        </Button>
                    ) : null}
                </>
            }
        >
            <FetchOrderErrorTable dataSource={dataSource} />
        </Modal>
    );
};

export default observer(FetchOrderErrorModal);
